import { render, staticRenderFns } from "./legal-person.vue?vue&type=template&id=58d36c40"
import script from "./legal-person.vue?vue&type=script&lang=js"
export * from "./legal-person.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports